module.exports = __webpack_public_path__ + "img/MEDIA108.b6192fd9.jpg";